import React from 'react'
import { Col, Nav, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { useTranslation } from "react-i18next"


export default function SubMenuCandidateSelection({ section }) {
    const { t } = useTranslation()
    return (
        <Row className='mt-3 mb-5'>
            <Col>
                <Nav defaultActiveKey="/seasons" as="ul" className='selection-submenu'>
                    <Nav.Item as="li">
                        <Nav.Link active={section === "activeProcesses"} as={Link} to="/candidate/active-processes">{t("selection.submenu.activeProcesses")}</Nav.Link>
                    </Nav.Item>
                    <Nav.Item as="li">
                        <Nav.Link active={section === "completedProcesses"} as={Link} to="/candidate/completed-processes">{t("selection.submenu.finishedProcesses")}</Nav.Link>
                    </Nav.Item>
                    <Nav.Item as="li">
                        <Nav.Link active={section === "requestsSent"} as={Link} to="/candidate/requestsSent">{t("selection.submenu.requestsSent")}</Nav.Link>
                    </Nav.Item>
                </Nav>
            </Col>
        </Row>
    )
}